import { defineMessages } from 'react-intl';

export default defineMessages({
    wmicTrainingMaterialLink: {
        id: 'portal.index.TrainingMaterialLink',
        defaultMessage: 'Training Material'
    }
});